var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMisPostulacionesEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 0H8.4C8.7713 0 9.1274 0.1475 9.38995 0.41005C9.6525 0.672601 9.8 1.0287 9.8 1.4V2.8H12.6C12.9713 2.8 13.3274 2.9475 13.5899 3.21005C13.8525 3.4726 14 3.8287 14 4.2V6.8223C14 7.30086 13.4014 7.58463 12.9665 7.38507C12.7533 7.28727 12.6 7.08074 12.6 6.84622V4.2H1.4V11.9H6.56366C6.84777 11.9 7.0874 12.1135 7.16777 12.386C7.29413 12.8145 7.00317 13.3 6.55647 13.3H1.4C1.0287 13.3 0.672601 13.1525 0.41005 12.8899C0.1475 12.6274 0 12.2713 0 11.9V4.2C0 3.8287 0.1475 3.4726 0.41005 3.21005C0.672601 2.9475 1.0287 2.8 1.4 2.8H4.2V1.4C4.2 1.0287 4.3475 0.672601 4.61005 0.41005C4.8726 0.1475 5.2287 0 5.6 0ZM8.4 2.8V1.4H5.6V2.8H8.4ZM8.4 11.2C8.4 10.8134 8.7134 10.5 9.1 10.5H10.5V9.1C10.5 8.7134 10.8134 8.4 11.2 8.4C11.5866 8.4 11.9 8.7134 11.9 9.1V10.5H13.3C13.6866 10.5 14 10.8134 14 11.2C14 11.5866 13.6866 11.9 13.3 11.9H11.9V13.3C11.9 13.6866 11.5866 14 11.2 14C10.8134 14 10.5 13.6866 10.5 13.3V11.9H9.1C8.7134 11.9 8.4 11.5866 8.4 11.2Z",
    fill: "#dddddd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisPostulacionesEmpty);
export default __webpack_public_path__ + "static/media/misPostulacionesEmpty.a1eabc585b53248a65a103d82a89d4d2.svg";
export { ForwardRef as ReactComponent };